import {
  useUpdateVenue as useUpdateVenueApi,
  VenueCategoryUnionType,
} from '@api';
import { useNotification, VenueFormValuesType } from '@common';
import { AxiosError } from 'axios';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_VENUE';

type UseUpdateVenueReturnType = {
  updateVenue: (data: VenueFormValuesType) => Promise<void>;
};

export const useUpdateVenue = (venueId: string): UseUpdateVenueReturnType => {
  const { mutateAsync: updateVenueMutation } = useUpdateVenueApi();

  const { showSuccess, showError } = useNotification();

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenue = async (data: VenueFormValuesType) => {
    const variables = {
      id: venueId,
      data: { ...data, category: data.category as VenueCategoryUnionType },
    };
    const options = { onSuccess, onError };

    await updateVenueMutation(variables, options);
  };

  return { updateVenue };
};
